import type { EntityAttribute } from '@onefootprint/request-types/dashboard';

const getTruncatedName = (attributes: EntityAttribute[]) => {
  // find an attribute in attributes that has identifier with value IdDI.fistName
  const firstNameAttribute = attributes.find(attribute => attribute.identifier === 'id.first_name');

  // find an attribute in attributes that has identifier with value IdDI.lastName
  const lastNameAttribute = attributes.find(attribute => attribute.identifier === 'id.last_name');

  if (!firstNameAttribute) {
    return '-';
  }

  const firstName = firstNameAttribute.value;
  if (!firstName) {
    return '-';
  }

  const lastNameInitial = lastNameAttribute?.transforms.prefix1 ? `${lastNameAttribute.transforms.prefix1}.` : '';

  const name = `${firstName} ${lastNameInitial}`.trim();
  return name;
};

export default getTruncatedName;
